// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_dmu_plati-online_plati-online_module_ts":"319e344809a1ef5c","src_app_dmu_plata-taxa_plata-taxa_module_ts":"3cc111d30ad801ea"}[chunkId] + ".js";
};